import React from 'react';
import { Truck, RotateCcw, ShieldCheck, CreditCard } from 'lucide-react';

export default function FeaturesBar() {
  const features = [
    {
      icon: Truck,
      title: 'ENVIO EXPRESSO',
      description: 'Em até 24h ou retirada grátis'
    },
    {
      icon: RotateCcw,
      title: '1ª TROCA GRÁTIS',
      description: 'Até 30 dias para experimentar'
    },
    {
      icon: ShieldCheck,
      title: 'DROPS AUTÊNTICOS',
      description: 'Produtos oficiais URBRACE'
    },
    {
      icon: CreditCard,
      title: 'PARCELAMENTO',
      description: 'Até 6x sem juros ou PIX imediato'
    }
  ];

  return (
    <section className="bg-urb-dark/95 border-b border-urb-border py-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6">
          {features.map((item, idx) => {
            const Icon = item.icon;
            return (
              <div 
                key={idx} 
                className="flex items-center gap-3.5 p-3 rounded-xl bg-urb-card/40 border border-urb-border/50 hover:border-urb-primary/30 transition-colors"
              >
                <div className="w-10 h-10 rounded-lg bg-urb-primary/10 border border-urb-primary/20 flex items-center justify-center shrink-0 text-urb-primary">
                  <Icon className="w-5 h-5" />
                </div>
                <div className="overflow-hidden">
                  <h4 className="text-xs sm:text-sm font-extrabold text-white tracking-wider uppercase truncate">
                    {item.title}
                  </h4>
                  <p className="text-[11px] text-urb-text-secondary truncate">
                    {item.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
